import Model from './Model';

export default class Voucher extends Model {
    readonly id: number;
    readonly code: string;
    readonly code_masked: string;
    readonly reseller_id: number;
    readonly resellerId: number;
    readonly amount?: {
        amount: number | string;
        currency: string;
    };
    readonly amount_value: number;
    readonly amount_currency: string;
    readonly created_at: string;
    readonly consumed_at: string;
    readonly print_count: number;
    readonly print_url: string;
    readonly can_be_printed: boolean;
}

export enum VoucherStatuses {
    ALL = 'all',
    USED = 'used',
    NOT_USED = 'not_used',
}

export type VoucherStatus = `${VoucherStatuses}`;
